<template>
    <div v-loading="loading">
        <div class="column-layout clearfix">
            <div v-cloak class="left-column fl">
                <!--<div class="tab-container base">
                    <div class="tabs-nav">
                        <ul class="head">
                            <li class="head-item current">菜单</li>
                        </ul>
                    </div>
                </div>-->
                <div class="fixed-tree" id="tree-menu" style="height: 445px;">
                    <swb-menu-tree :roleId="roleId" :enableSearch="true" @notity-change="notityChange($event)"></swb-menu-tree>
                </div>
            </div>
            <div class="right-column fl">
                <div style="background-color: #fafafa;line-height: 49px;height: 49px;">
                    <span class="ml15">当前菜单资源：【<span class="font-red" v-if="sysMenuInfo.id != null">{{sysMenuInfo.name}}</span><span v-else>无</span>】</span>
                    <button @click="updateRetailerComRoleResc();" style="float: right;margin-top: 8px;" class='swb-btn swb-btn-small mr15' v-if="!readOnly">
                        <span>保存</span>
                    </button>
                </div>
                <div class="table-layout">
                    <el-checkbox :disabled="readOnly" v-if="actionList.length > 0" :indeterminate="isIndeterminate" v-model="checked" @change="handleCheckAllChange">全选</el-checkbox>
                    <ul v-if="actionList.length > 0" style="margin-top: 50px;" class="switch-list clearfix ml10">
                        <el-checkbox-group @change="handleCheckedChange" v-model="roleResc.actionList">
                            <li v-for="action in actionList" class="switch-item ellipsis-1" style="width: auto;margin-right: 30px;">
                                <el-checkbox :disabled="readOnly" :label="action.code">
                                    <span>{{action.name}}</span>
                                </el-checkbox>
                            </li>
                        </el-checkbox-group>
                    </ul>
                    <ul v-if="actionList == null || actionList.length <= 0" style="margin-top: 50px;" class="switch-list clearfix ml10">
                        <li class="switch-item ellipsis-1" style="width: auto;margin-right: 30px;">
                            <span>当前菜单资源没有相关操作</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    //
    import retailerAuthxApi from '../../api/retailerAuthx'
    import userApi from '../../api/user'
    import settingApi from '../../api/setting'
    //
    import SwbSysMenuTree from '../comn/SysMenuTree';
    Vue.regist(SwbSysMenuTree);
    export default {
        name: 'swb-com-role-resc-action',
        desc: '公司岗位资源动作',
        props: {
            roleId: {
                type: Number,
                default: null
            },
            roleName: {
                type: String,
                default: null
            },
            bizUnitLevel: {
                type: Number,
                default: null
            },
            readOnly: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                loading: false,
                thisRescId: null,
                sysMenuInfo: {},
                actionList: [],
                roleResc: {
                    actionList: []
                },
                //
                checked: false,
                isIndeterminate: false
            }
        },
        created: function () {
            //
        },
        methods: {
            notityChange: function (eventData) {
                this.thisRescId = eventData.rescId;
                this.sysMenuInfo = eventData;
                //
                this.checked = false;
                this.getSysRescActions();
            },
            /*getSysResc: function () {
             let self = this;
             let postData = {};
             postData.id = this.thisRescId;
             self.loading = true;
             settingApi.getSysResc(postData, function (result) {
             self.loading = false;
             if(result.type === 'info') {
             let sysResc = result.data;
             self.actionList = sysResc.actionList || [];
             } else {
             self.$message.error(result.message);
             }

             });
             },*/
            getSysRescActions: function () {
                let self = this;
                let postData = {};
                let filterItems = {};
                filterItems.rescId = this.thisRescId;
                filterItems.bizUnitLevel = this.bizUnitLevel;
                postData.filterItems = filterItems;
                self.loading = true;
                settingApi.getSysRescActions(postData, function (result) {
                    self.loading = false;
                    if (result.type === 'info') {
                        //
                        let sysRescActionMap = getRescActionDefMap();
                        //
                        let showList = [];
                        let actionList = result.data || [];
                        for (let i = 0; i < actionList.length; i++) {
                            let sysRescAction = actionList[i];
                            if (Utils.isNoB(sysRescAction.name)) {
                                sysRescAction.name = sysRescActionMap[sysRescAction.code];
                            }
                            showList.push(sysRescAction);
                        }
                        //
                        self.actionList = showList;
                        self.getRetailerComRoleRescByRoleIdAndRescId();
                    } else {
                        self.$message.warning(result.message);
                    }

                });
            },
            getRetailerComRoleRescByRoleIdAndRescId: function () {
                let self = this;
                let postData = {};
                postData.roleId = this.roleId;
                postData.rescId = this.thisRescId;
                retailerAuthxApi.getRetailerComRoleRescByRoleIdAndRescId(postData, function (result) {
                    if (result.type === 'info') {
                        let roleResc = result.data;
                        let roleActionList = roleResc.actionList;
                        roleResc.dbActionList = roleActionList;
                        self.roleResc = roleResc;
                        if (roleActionList != null && roleActionList.length > 0) {
                            if (self.actionList.length <= roleActionList.length) {
                                self.checked = true;
                                self.isIndeterminate = false;
                            } else {
                                self.isIndeterminate = true;
                            }
                        }
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            handleCheckAllChange: function (checked) {
                let roleActionList = this.roleResc.actionList;
                roleActionList = [];
                if (checked) {
                    let actionList = this.actionList;
                    if (actionList != null && actionList.length > 0) {
                        actionList.forEach(function (item) {
                            roleActionList.push(item.code);
                        });
                    }
                }
                this.isIndeterminate = false;
                this.roleResc.actionList = Utils.merge([], roleActionList);
            },
            handleCheckedChange(value) {
                let checkedCount = value.length;
                this.checked = checkedCount >= this.actionList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.actionList.length;
            },
            updateRetailerComRoleResc: function () {
                let self = this;
                //
                let roleResc = self.roleResc;
                let actionList = roleResc.actionList;
                let dbActionList = roleResc.dbActionList;
                let compare = Utils.compareArrays(actionList, dbActionList);
                if (compare.more.length == 0 && compare.less.length == 0) {
                    self.$message.success("操作成功");
                    return;
                }
                let postData = {};
                postData.id = roleResc.id;
                postData.actionList = actionList;
                self.loading = true;
                retailerAuthxApi.updateRetailerComRoleRescs(postData, function (result, jqXhr) {
                    self.loading = false;
                    if (result.type == "info") {
                        self.$message.success("操作成功");
                        // 重新渲染列表
                        self.getRetailerComRoleRescByRoleIdAndRescId();
                    } else {
                        selfDlg.$message.error(result.message);
                    }
                });
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/authx/ComRoleRescAction.vue